exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-element-wrapper[data-v-bb7b5f80]{cursor:pointer}.header[data-v-bb7b5f80]{display:flex}.file-icon[data-v-bb7b5f80]{font-size:40px!important}.file-element[data-v-bb7b5f80]{display:flex;flex-direction:column;margin-left:12px}.file-size[data-v-bb7b5f80]{font-size:12px;padding-top:5px}", ""]);

// exports
